import { inject, Injectable } from '@angular/core';
import { ApiService } from 'app/services/api/api.service';
import { UtilsService } from 'app/services/utils.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CommonCrudService {
    private utils = inject(UtilsService);
    private _apiService = inject(ApiService);

    constructor() {}

    // ----------------------------------------------------------------------
    // @ Public methods
    // ----------------------------------------------------------------------

    // ----------------------------------------------------------------------
    // @ CRUD methods
    // ----------------------------------------------------------------------

    /**
     * @description
     * Get all
     * @returns
     */
    getAll(endpoint: string): Observable<any> {
        return this._apiService.get(endpoint);
    }

    /**
     * @description
     * Get single
     * @returns
     */
    getOne(endpoint: string, id: number): Observable<any> {
        return this._apiService.getOne(endpoint, id);
    }

    create(endpoint: string, data: any): Observable<any> {
        return this._apiService.post(endpoint, data);
    }

    update(endpoint: string, data: string, id: number): Observable<any> {
        return this._apiService.update(endpoint, data, id);
    }

    delete(endpoint: string, id: number): Observable<any> {
        return this._apiService.delete(endpoint, id);
    }
}
